import { Guid } from "devextreme-vue/common";
import chatIcon from "@/assets/icons/chatbot.svg";

const state = () => ({
  showChat: false,
  supportAgent: {
    id: "assistant",
    name: "Assistant",
    avatarUrl: chatIcon,
  },
  currentChatMessages: [],

  currentUser: {
    id: "user",
    name: "User",
  },
  aiAssistantAccessToken: {
    accessToken: "",
    expirationTime: null,
  },
  settings: null,
  typingUsers: [],
});

const getters = {};

const actions = {};

const mutations = {
  updateShowChat(state, val) {
    state.showChat = val;
  },
  setTypingUsers(state, users) {
    state.typingUsers = [...users];
  },
  addMessageToChat(state, val) {
    let assistantResponse = {
      id: new Guid().toString(),
      timestamp: new Date(),
      author: state.supportAgent,
      text: val.content,
    };
    state.currentChatMessages = [
      ...state.currentChatMessages,
      assistantResponse,
    ];

    sessionStorage.setItem(
      "chatMessages",
      JSON.stringify(state.currentChatMessages),
    );
  },
  fillSettings(state, val) {
    state.settings = val;
  },
  resetCurrentMessages(state) {
    state.currentChatMessages = [
      {
        id: new Guid().toString(),
        timestamp: new Date(),
        author: state.supportAgent,
        text: state.settings != null ? state.settings.introText : "",
      },
    ];
    if (
      JSON.parse(sessionStorage.getItem("chatMessages")) == null ||
      JSON.parse(sessionStorage.getItem("chatMessages")).length == 0
    )
      sessionStorage.setItem(
        "chatMessages",
        JSON.stringify(state.currentChatMessages),
      );
  },
  setAIAssistantAccessToken(state, val) {
    state.aiAssistantAccessToken.accessToken = val.accessToken;
    state.aiAssistantAccessToken.expirationTime = val.expirationTime;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
